import { RootState } from "../StoreHooks";

export const getPaxSettings = (state: RootState) => {
  const paxSettings = state.paxSettings || {};
  return { ...paxSettings };
};
